import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const KineticText = ({ lines, className = "", lineClassName = "", delay = 0 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "115%" }}
          animate={{ y: 0 }}
          transition={{ duration: 1.1, ease: EASE, delay: delay + i * 0.13 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);
